// Geboortevenster · Chart-preview: een preset op de kandidaattijd uit de segmenten (direct) en het behoud van de invoermodus bij overnemen.
// Overzicht van de feature: EgituraPlatform/docs/human-design/hd-birth-window.md

import { HdBodygraphChartPreset, HdBodygraphPlanetaryActivation } from '../bodygraph/hd-bodygraph.models';
import { toBirthWindowConfig } from './birth-window-activations.builder';

/**
 * Preview-chart voor de kandidaattijd uit de venstersegmenten (spec §3.3):
 * direct beschikbaar tijdens het slepen, zonder backend. Poorten en lijnen
 * zijn exact; base en lengtegraad ontbreken (0) tot het exacte document op
 * rust binnenkomt. Handwerk-layouts blijven staan zodat de chart niet springt.
 */
export function buildBirthWindowPreviewPreset(
  preset: HdBodygraphChartPreset,
  activations: readonly HdBodygraphPlanetaryActivation[],
): HdBodygraphChartPreset {
  return {
    ...preset,
    configuration: toBirthWindowConfig(activations),
    planetaryActivations: [...activations],
    metadata: { ...(preset.metadata ?? {}), birthWindowPreview: true },
  };
}

/**
 * Een vers `/calculate`-document meldt `isInUtc: true`; een chart die als
 * lokale tijd werd ingevoerd houdt die invoermodus (zelfde regel als het
 * bewerkpad in `HdChartLibraryService.recalculate`).
 */
export function preserveBirthEntryMode(fresh: HdBodygraphChartPreset, original: HdBodygraphChartPreset): HdBodygraphChartPreset {
  const originalTime = (original.birthData as { time?: { isInUtc?: boolean | null } | null } | undefined)?.time;
  const freshTime = (fresh.birthData as { time?: { isInUtc?: boolean | null } | null } | undefined)?.time;
  const originalIsInUtc = originalTime?.isInUtc === true;
  if (!freshTime || (freshTime.isInUtc === true) === originalIsInUtc) return fresh;
  return { ...fresh, birthData: { ...fresh.birthData, time: { ...freshTime, isInUtc: originalIsInUtc } } };
}
